import React, { useContext, useEffect, useState } from "react";
import {
  GetEmployeeGoals,
  addKra,
  updateKra,
  updateKpi,
  addKpi,
  DeleteKpi,
  DeleteKra,
  updateProgress,
  PublishUnpublish,
  CopyPreviousKra,
} from "./PMSService";
import { TostMsg } from "../../../App";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { Dropdown } from "bootstrap/dist/js/bootstrap.bundle.min";
import { InputSwitch } from "primereact/inputswitch";

const AssessmentGoals = () => {
  const toster = useContext(TostMsg);

  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");

  const [goals, setGoals] = useState([]);
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("User"));
  // ---------------------------------------------------------
  // KRA MODAL
  // ---------------------------------------------------------

  const [showAddKra, setShowAddKra] = useState(false);
  const [editingKra, setEditingKra] = useState(null);

  const [kraTitle, setKraTitle] = useState("");
  const [kraDescription, setKraDescription] = useState("");
  const [kraTargetDate, setKraTargetDate] = useState("");

  const [savingKra, setSavingKra] = useState(false);
  const [kraWeightage, setKraWeightage] = useState("");

  // ---------------------------------------------------------
  // KPI MODAL
  // ---------------------------------------------------------

  const [showAddKpi, setShowAddKpi] = useState(false);
  const [editingKpi, setEditingKpi] = useState(null);
  const [selectedKraId, setSelectedKraId] = useState(null);

  const [kpiDescription, setKpiDescription] = useState("");
  const [kpiTargetDate, setKpiTargetDate] = useState("");

  const [savingKpi, setSavingKpi] = useState(false);

  // ---------------------------------------------------------
  // PROGRESS MODAL
  // ---------------------------------------------------------

  const [showProgressModal, setShowProgressModal] = useState(false);

  const [progressKpiId, setProgressKpiId] = useState(null);
  const [progressKpiName, setProgressKpiName] = useState("");
  const [progressPct, setProgressPct] = useState(0);
  const [progressNarrative, setProgressNarrative] = useState("");

  const [savingProgress, setSavingProgress] = useState(false);
  const [kraForm, setKraForm] = useState({
    Id: 0,
    EmpId: 0,
    Title: "",
    Description: "",
    TargetDate: "",
  });
  const [kraErrors, setKraErrors] = useState({});
  const [kpiErrors, setKpiErrors] = useState({});
  const [progressErrors, setProgressErrors] = useState({});
  const [deleteKra, setDeleteKra] = useState(false);
  const [deleteKpi, setDeleteKpi] = useState(false);
  const [selectedDeleteKra, setSelectedDeleteKra] = useState(0);
  const [selectedDeleteKpi, setSelectedDeleteKpi] = useState(0);
  const [kraPublishStatus, setKRAPublishStatus] = useState(false);
  const [employeeKraName, setEmployeeKRAName] = useState({});
   let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
   const [kraPublish, setKRAPublish] = useState(false);

  // ---------------------------------------------------------
  // DELETE
  // ---------------------------------------------------------

  const [deleting, setDeleting] = useState(false);

  // ---------------------------------------------------------
  // GET LOGGED-IN USER
  // ---------------------------------------------------------

  const getLoggedInUser = () => {
    try {
      const user =
        JSON.parse(localStorage.getItem("User")) ||
        JSON.parse(localStorage.getItem("user"));

      return user || {};
    } catch (error) {
      return {};
    }
  };

  // ---------------------------------------------------------
  // GET EMPLOYEE ID
  // ---------------------------------------------------------

  //   const getEmployeeId = () => {
  //     const user = getLoggedInUser();

  //     return (
  //       user ||
  //       ""
  //     );
  //   };

  async function reportingManager() {
    var params1 = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.Id,
      IsDirectReportOrHierarchy: 3,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000,
      EmployeeId: userDetails?.Id,
      IsSuggestedOnly: 0,
    };
    try {
      let hierarchyList = await getEmployeeList(params1);
      setEmployees(hierarchyList.Data);
    } catch (error) {
      // setIsLoading(false);
    }
  }

  // ---------------------------------------------------------
  // LOAD GOALS
  // ---------------------------------------------------------

  const getGoals = async (selectedEmployeeData) => {
    if (!selectedEmployeeData) return;

    try {
      setLoading(true);

      const params = {
        empId: selectedEmployeeData,
      };

      const response = await GetEmployeeGoals(params);

      console.log("Employee Goals API:", response);

      const responseData = response?.Data?.Kras ?? [];

      const publishResponse = response?.Data?.PublishStatus;

      setKRAPublishStatus(publishResponse);

      let goalList = [];

      if (Array.isArray(responseData)) {
        goalList = responseData.map((kra) => ({
          ...kra,
          PublishStatus:
            publishResponse.PublishStatus === "Published"
              ? setIsPublished(true)
              : setIsPublished(false),
        }));
      }

      setGoals(goalList);
    } catch (error) {
      console.error("Get employee goals error:", error);

      const message =
        error?.response?.data?.Message ||
        error?.response?.data?.message ||
        "Failed to load goals.";

      toster?.current?.error(message);
    } finally {
      setLoading(false);
    }
  };

  // ---------------------------------------------------------
  // INITIAL LOAD
  // ---------------------------------------------------------

  useEffect(() => {
    const employeeData = userDetails?.EmpId;

    if (employeeData) {
      reportingManager();
      setSelectedEmployee(employeeData);
      getGoals(employeeData);
    }
    userPermissions.map((UserPermission) => {
      if (
        UserPermission.PermissionName == "PMS.Review" &&
        UserPermission.IsGranted == true
      ) {
        setKRAPublish(true);
      }
    })
  }, []);

  const closeKraModal = () => {
    setShowAddKra(false);
    setEditingKra(null);

    setKraTitle("");
    setKraDescription("");
    setKraTargetDate("");

    setKraErrors({});
  };

  // ---------------------------------------------------------
  // VALIDATION HELPERS
  // ---------------------------------------------------------

  //   const validateKra = () => {
  //     const errors = {};

  //     const title = kraTitle.trim();
  //     const description = kraDescription.trim();
  //     const weightage = Number(kraWeightage);
  //     const existingWeightage = getExistingWeightage();

  //     if (!title) {
  //       errors.title = "KRA title is required.";
  //     } else if (title.length < 3) {
  //       errors.title = "KRA title must be at least 3 characters.";
  //     } else if (title.length > 150) {
  //       errors.title = "KRA title cannot exceed 150 characters.";
  //     }

  //     if (description.length > 500) {
  //       errors.description = "KRA description cannot exceed 500 characters.";
  //     }

  //     if (kraTargetDate) {
  //       const selectedDate = new Date(kraTargetDate);

  //       if (Number.isNaN(selectedDate.getTime())) {
  //         errors.targetDate = "Please select a valid target date.";
  //       }
  //     }

  //     if (kraWeightage === "" || !Number.isFinite(weightage) || weightage <= 0) {
  //       errors.weightage = "Please enter a weightage greater than 0%.";
  //     } else if (weightage > 100) {
  //       errors.weightage = "KRA weightage cannot exceed 100%.";
  //     } else if (existingWeightage + weightage > 100) {
  //       errors.weightage =
  //         `Total KRA weightage cannot exceed 100%. ` +
  //         `Available weightage is ${Math.max(0, 100 - existingWeightage)}%.`;
  //     }

  //     setKraErrors(errors);

  //     return Object.keys(errors).length === 0;
  //   };

  const validateKpi = () => {
    const errors = {};

    const description = kpiDescription.trim();

    if (!description) {
      errors.description = "KPI description is required.";
    } else if (description.length < 3) {
      errors.description = "KPI description must be at least 3 characters.";
    } else if (description.length > 500) {
      errors.description = "KPI description cannot exceed 500 characters.";
    }

    if (kpiTargetDate) {
      const selectedDate = new Date(kpiTargetDate);

      if (Number.isNaN(selectedDate.getTime())) {
        errors.targetDate = "Please select a valid target date.";
      }
    }

    if (!selectedKraId) {
      errors.kra = "KRA is required.";
    }

    setKpiErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const getKraWeightage = (kra) =>
    Number(kra?.Weightage ?? kra?.KraWeightage ?? kra?.weightage ?? 0);

  const totalKraWeightage = goals.reduce(
    (total, kra) => total + getKraWeightage(kra),
    0,
  );

  // For editing, exclude the current KRA's weightage.
  // For adding, use the employee's complete existing total.
  const getExistingWeightage = () => {
    return editingKra
      ? goals
          .filter(
            (kra) => String(getKraId(kra)) !== String(getKraId(editingKra)),
          )
          .reduce((total, kra) => total + getKraWeightage(kra), 0)
      : totalKraWeightage;
  };

  const validateKra = () => {
    const errors = {};

    const title = kraTitle.trim();
    const description = kraDescription.trim();
    const weightage = Number(kraWeightage);
    const existingWeightage = getExistingWeightage();

    if (!title) {
      errors.title = "KRA title is required.";
    } else if (title.length < 3) {
      errors.title = "KRA title must be at least 3 characters.";
    } else if (title.length > 150) {
      errors.title = "KRA title cannot exceed 150 characters.";
    }

    if (description.length > 500) {
      errors.description = "KRA description cannot exceed 500 characters.";
    }

    if (kraTargetDate) {
      const selectedDate = new Date(kraTargetDate);

      if (Number.isNaN(selectedDate.getTime())) {
        errors.targetDate = "Please select a valid target date.";
      }
    }

    if (kraWeightage === "" || !Number.isFinite(weightage) || weightage <= 0) {
      errors.weightage = "Please enter a weightage greater than 0%.";
    } else if (weightage > 100) {
      errors.weightage = "KRA weightage cannot exceed 100%.";
    } else if (!editingKra && existingWeightage >= 100) {
      errors.weightage =
        "This employee's total KRA weightage is already 100%. You cannot add another KRA.";
    } else if (existingWeightage + weightage > 100) {
      errors.weightage =
        `Total KRA weightage cannot exceed 100%. ` +
        `Available weightage is ${Math.max(0, 100 - existingWeightage)}%.`;
    }

    setKraErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const validateProgress = () => {
    const errors = {};

    if (!progressKpiId) {
      errors.kpi = "KPI is required.";
    }

    const percentage = Number(progressPct);

    if (
      progressPct === "" ||
      progressPct === null ||
      progressPct === undefined ||
      Number.isNaN(percentage)
    ) {
      errors.progress = "Completion percentage is required.";
    } else if (percentage < 0 || percentage > 100) {
      errors.progress = "Completion percentage must be between 0 and 100.";
    }

    if (progressNarrative.trim().length > 1000) {
      errors.narrative = "Progress narrative cannot exceed 1000 characters.";
    }

    setProgressErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const handleKraChange = (e) => {
    const { name, value } = e.target;

    setKraForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ---------------------------------------------------------
  // HELPERS
  // ---------------------------------------------------------

  const getKraId = (kra) => {
    return kra?.KraId ?? kra?.KRAId ?? kra?.GoalId ?? kra?.Id ?? kra?.id;
  };

  const getKpiId = (kpi) => {
    return kpi?.KpiId ?? kpi?.KPIId ?? kpi?.GoalKpiId ?? kpi?.Id ?? kpi?.id;
  };

  const getKraTitle = (kra) => {
    return (
      kra?.Title ??
      kra?.KraTitle ??
      kra?.KRATitle ??
      kra?.Name ??
      kra?.GoalTitle ??
      "Untitled KRA"
    );
  };

  const getKraDescription = (kra) => {
    return (
      kra?.Description ?? kra?.KraDescription ?? kra?.GoalDescription ?? ""
    );
  };

  const getKraTargetDate = (kra) => {
    return kra?.TargetDate ?? kra?.KraTargetDate ?? kra?.DueDate ?? "";
  };

  const getKpiTitle = (kpi) => {
    return (
      kpi?.Description ??
      kpi?.KpiDescription ??
      kpi?.KPIDescription ??
      kpi?.Title ??
      kpi?.Name ??
      "Untitled KPI"
    );
  };

  const getKpiTargetDate = (kpi) => {
    return kpi?.TargetDate ?? kpi?.KpiTargetDate ?? kpi?.DueDate ?? "";
  };

  const getKpiProgress = (kpi) => {
    return Number(kpi?.CompletionPct ?? 0);
  };

  const getKpiNarrative = (kpi) => {
    return (
      kpi?.ProgressNarrative ?? kpi?.Narrative ?? kpi?.ProgressComment ?? ""
    );
  };

  const getKpiUpdatedDate = (kpi) => {
    return (
      kpi?.LastUpdatedOn ??
      kpi?.UpdatedOn ??
      kpi?.ModifiedOn ??
      kpi?.LastUpdatedDate ??
      ""
    );
  };

  const getKpiUpdatedBy = (kpi) => {
    return (
      kpi?.LastUpdatedByName ?? kpi?.UpdatedByName ?? kpi?.LastUpdatedBy ?? ""
    );
  };

  const getKpis = (kra) => {
    return (
      kra?.Kpis ??
      kra?.KPIs ??
      kra?.KPIList ??
      kra?.KpiList ??
      kra?.GoalsKpis ??
      []
    );
  };

  const formatDate = (date) => {
    if (!date) return "Ongoing";

    const parsed = new Date(date);

    if (Number.isNaN(parsed.getTime())) {
      return date;
    }

    return parsed.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  const getInitials = (index) => {
    return `K${index + 1}`;
  };

  // ---------------------------------------------------------
  // OPEN ADD KRA
  // ---------------------------------------------------------

  const openAddKra = () => {
    if (totalKraWeightage >= 100) {
      toster?.current?.error(
        "This employee's total KRA weightage is already 100%. You cannot add another KRA.",
      );
      return;
    }

    setEditingKra(null);
    setKraTitle("");
    setKraDescription("");
    setKraTargetDate("");

    setKraWeightage(String(Math.max(0, 100 - totalKraWeightage)));

    setKraErrors({});
    setShowAddKra(true);
  };

  const closeKpiModal = () => {
    setShowAddKpi(false);
    setEditingKpi(null);
    setSelectedKraId(null);

    setKpiDescription("");
    setKpiTargetDate("");

    setKpiErrors({});
  };

  const closeProgressModal = () => {
    setShowProgressModal(false);

    setProgressKpiId(null);
    setProgressKpiName("");
    setProgressPct(0);
    setProgressNarrative("");

    setProgressErrors({});
  };

  // ---------------------------------------------------------
  // OPEN EDIT KRA
  // ---------------------------------------------------------

  const openEditKra = (kra) => {
    setEditingKra(kra);

    setKraTitle(getKraTitle(kra));
    setKraDescription(getKraDescription(kra));

    const targetDate = getKraTargetDate(kra);
    setKraTargetDate(targetDate ? String(targetDate).substring(0, 10) : "");

    setKraWeightage(String(getKraWeightage(kra)));
    setKraErrors({});
    setShowAddKra(true);
  };
  // ---------------------------------------------------------
  // SAVE KRA
  // ---------------------------------------------------------

  const handleSaveKra = async () => {
    const isValid = validateKra();

    if (!isValid) {
      return;
    }

    try {
      setSavingKra(true);

      const user = getLoggedInUser();
      console.log(selectedEmployee);
      const employeeId = Number(selectedEmployee || 0);

      if (!employeeId) {
        setKraErrors({
          employee: "Employee information is missing.",
        });

        toster?.current?.error("Employee information is missing.");

        return;
      }

      const payload = {
        Id: editingKra ? Number(getKraId(editingKra)) : 0,

        EmpId: employeeId,

        Title: kraTitle.trim(),

        Description: kraDescription.trim(),

        TargetDate: kraTargetDate || "",
        Weightage: Number(kraWeightage),
      };

      console.log(
        editingKra ? "Update KRA Payload:" : "Add KRA Payload:",
        payload,
      );

      let response;

      if (editingKra) {
        response = await updateKra(payload, getKraId(editingKra));
      } else {
        response = await addKra(payload);
      }

      console.log("KRA API Response:", response);

      if (response?.StatusCode === 2000) {
        toster.current.success(
          editingKra ? "KRA updated successfully." : "KRA added successfully.",
        );
      } else {
        toster.current.error(response?.Message || "Failed to save Kra");
      }

      setKraTitle("");
      setKraDescription("");
      setKraTargetDate("");
      setKraErrors({});
      setEditingKra(null);
      setShowAddKra(false);

      // IMPORTANT: refresh using selected employee
      await getGoals(selectedEmployee);
    } catch (error) {
      //   console.error("Save KRA Error:", error);
      toster.current.error(
        // error?.response?.data?.Message ||
        //   error?.response?.data?.message ||
        //   error?.message ||
        "Failed to save Kra",
      );
    } finally {
      setSavingKra(false);
    }
  };

  // ---------------------------------------------------------
  // DELETE KRA
  // ---------------------------------------------------------

  const handleDeleteKra = async () => {
    // const kraId = getKraId(kra);

    if (!selectedDeleteKra) return;

    // const confirmed = window.confirm(
    //   `Are you sure you want to delete "${getKraTitle(kra)}"?`,
    // );

    // if (!confirmed) return;

    try {
      setDeleting(true);

      const response = await DeleteKra(selectedDeleteKra);

      if (response?.StatusCode === 2000) {
        toster?.current?.success(
          response?.Message ||
            response?.data?.Message ||
            "KRA deleted successfully.",
        );

        await getGoals(selectedEmployee);
      }

      setDeleteKra(false);
    } catch (error) {
      console.error("Delete KRA error:", error);

      toster?.current?.error(
        error?.response?.data?.Message ||
          error?.response?.data?.message ||
          "Failed to delete KRA.",
      );
      setDeleteKra(false);
    } finally {
      setDeleting(false);
    }
  };

  // ---------------------------------------------------------
  // OPEN ADD KPI
  // ---------------------------------------------------------

  const openAddKpi = (kra) => {
    setSelectedKraId(getKraId(kra));
    setEditingKpi(null);

    setKpiDescription("");
    setKpiTargetDate("");

    setKpiErrors({});

    setShowAddKpi(true);
  };

  // ---------------------------------------------------------
  // OPEN EDIT KPI
  // ---------------------------------------------------------

  const openEditKpi = (kra, kpi) => {
    setSelectedKraId(getKraId(kra));
    setEditingKpi(kpi);

    setKpiDescription(getKpiTitle(kpi));

    const targetDate = getKpiTargetDate(kpi);

    setKpiTargetDate(targetDate ? String(targetDate).substring(0, 10) : "");

    setKpiErrors({});

    setShowAddKpi(true);
  };

  // ---------------------------------------------------------
  // SAVE KPI
  // ---------------------------------------------------------

  const handleSaveKpi = async () => {
    const errors = {};

    const description = kpiDescription.trim();

    // Validation
    if (!selectedKraId) {
      errors.kra = "Please select a KRA.";
    }

    if (!description) {
      errors.description = "KPI description is required.";
    } else if (description.length < 3) {
      errors.description = "KPI description must be at least 3 characters.";
    } else if (description.length > 1000) {
      errors.description = "KPI description cannot exceed 1000 characters.";
    }

    //   if (!kpiTargetDate) {
    //     errors.targetDate = "Target date is required.";
    //   }

    setKpiErrors(errors);

    // Stop API call if validation fails
    if (Object.keys(errors).length > 0) {
      return;
    }

    try {
      setSavingKpi(true);

      const payload = {
        Id: editingKpi ? Number(editingKpi?.Id || editingKpi?.KpiId || 0) : 0,

        KraId: Number(selectedKraId),

        Description: description,

        TargetDate: kpiTargetDate,
      };

      console.log("Add KPI Payload:", payload);

      let response;

      if (editingKpi) {
        response = await updateKpi(
          payload,
          Number(editingKpi?.Id || editingKpi?.KpiId || 0),
        );
      } else {
        response = await addKpi(payload, Number(selectedKraId));
      }

      if (
        response?.StatusCode === 2000 ||
        response?.statusCode === 200 ||
        response?.status === "Success"
      ) {
        toster?.current?.success(
          editingKpi ? "KPI updated successfully." : "KPI added successfully.",
        );

        // Reset form
        setKpiDescription("");
        setKpiTargetDate("");
        setEditingKpi(null);
        setKpiErrors({});

        setShowAddKpi(false);

        // Refresh goals/KPIs
        await getGoals(selectedEmployee);
      } else {
        toster?.current?.error(
          response?.Message || response?.message || "Unable to save KPI.",
        );
      }
    } catch (error) {
      console.error("Save KPI Error:", error);

      toster?.current?.error(
        error?.response?.data?.Message ||
          error?.response?.data?.message ||
          "Something went wrong while saving KPI.",
      );
    } finally {
      setSavingKpi(false);
    }
  };

  // ---------------------------------------------------------
  // DELETE KPI
  // ---------------------------------------------------------

  const handleDeleteKpi = async () => {
    // const kpiId = getKpiId(kpi);

    if (!selectedDeleteKpi) return;

    // const confirmed = window.confirm(
    //   `Are you sure you want to delete "${getKpiTitle(kpi)}"?`,
    // );

    // if (!confirmed) return;

    try {
      setDeleting(true);

      const response = await DeleteKpi(selectedDeleteKpi);

      if (response?.StatusCode === 2000) {
        toster?.current?.success(
          response?.Message ||
            response?.data?.Message ||
            "KPI deleted successfully.",
        );

        await getGoals(selectedEmployee);
      }

      setDeleteKpi(false);
    } catch (error) {
      console.error("Delete KPI error:", error);

      toster?.current?.error(
        error?.response?.data?.Message ||
          error?.response?.data?.message ||
          "Failed to delete KPI.",
      );
      setDeleteKpi(false);
    } finally {
      setDeleting(false);
      setDeleteKpi(false);
    }
  };

  // ---------------------------------------------------------
  // OPEN PROGRESS
  // ---------------------------------------------------------

  const openProgress = (kpi) => {
    const kpiId = getKpiId(kpi);

    setProgressKpiId(kpiId);
    setProgressKpiName(getKpiTitle(kpi));
    setProgressPct(getKpiProgress(kpi));
    setProgressNarrative(getKpiNarrative(kpi));

    setShowProgressModal(true);
  };

  // ---------------------------------------------------------
  // SAVE PROGRESS
  // ---------------------------------------------------------

  const handleSaveProgress = async () => {
    const isValid = validateProgress();

    if (!isValid) {
      return;
    }

    let percentage = Number(progressPct);

    percentage = Math.max(0, Math.min(100, percentage));

    try {
      setSavingProgress(true);

      const payload = {
        CompletionPct: percentage,
        Narrative: progressNarrative.trim(),
      };

      const response = await updateProgress(payload, progressKpiId);

      console.log("Update KPI progress response:", response);

      const success =
        response?.StatusCode === 200 ||
        response?.StatusCode === 2000 ||
        response?.status === 200 ||
        response?.status === "Success" ||
        response?.data?.StatusCode === 200 ||
        response?.data?.StatusCode === 2000 ||
        response?.data?.status === "Success";

      if (!success) {
        throw new Error(
          response?.Message ||
            response?.message ||
            response?.data?.Message ||
            response?.data?.message ||
            "Failed to update KPI progress.",
        );
      }

      toster?.current?.success(
        response?.Message ||
          response?.message ||
          response?.data?.Message ||
          response?.data?.message ||
          "KPI progress updated successfully.",
      );

      setShowProgressModal(false);
      setProgressErrors({});

      await getGoals(selectedEmployee);
    } catch (error) {
      console.error("Update KPI progress error:", error);

      toster?.current?.error(
        error?.response?.data?.Message ||
          error?.response?.data?.message ||
          error?.message ||
          "Failed to update KPI progress.",
      );
    } finally {
      setSavingProgress(false);
    }
  };

  // ---------------------------------------------------------
  // CHANGE EMPLOYEE
  // ---------------------------------------------------------

  const handleEmployeeChange = (e) => {
    const value = e.target.value;

    setSelectedEmployee(value);

    if (value) {
      const employee =
        String(userDetails?.EmpId) === value
          ? userDetails
          : employees.find((emp) => String(emp.EmpId) === value);

      setEmployeeKRAName(employee);
      if (employee) {
        getGoals(employee?.EmpId);
      }
    }
  };

  const [isPublished, setIsPublished] = useState(false);
  const handlePublishUnpublish = async (e) => {
    console.log(e.target.value);
    setIsPublished(e.target.value);

    try {
      const params = {};

      const response = await PublishUnpublish(selectedEmployee, params);

      if (response?.StatusCode === 2000) {
        toster.current.success("KRAs published successfully");
      } else {
        toster.current.error(response?.Message);
      }

      getGoals(selectedEmployee);
    } catch (error) {}
  };

  const handleCopyPreviousKra = async () => {
    try {
      const params = {
        ToGoalCycleId: kraPublishStatus?.GoalCycleId,
      
        EmpId: selectedEmployee,
      };

      const response = await CopyPreviousKra(params);

       if(response?.StatusCode === 2000 && response?.Data?.CarriedForwardKRAs === 0 && response?.Data?.CarriedForwardKPIs === 0 ){
        toster.current.error(response?.Data?.Message);
      }
    else  if(response?.StatusCode === 2000){
        toster.current.success('Previous KRA copied successfully');
        getGoals(selectedEmployee);
      }
      
    } catch (error) {
        toster.current.error('Unable to copy previous KRA');
    }
  };

  // ---------------------------------------------------------
  // RENDER
  // ---------------------------------------------------------

  return (
    <div className="container-fluid">
      <div className="row g-3 assessment-module">
        <div className="og-main">
          {/* PAGE HEADER */}
          <div className="og-page-header">
            <div className="og-left-header">
              <div className="og-breadcrumb">
                <a
                  href="/Assessment/Employee/Dashboard"
                  style={{
                    color: "#EC4119",
                    textDecoration: "none",
                  }}
                >
                  My Dashboard
                </a>{" "}
                › Goals & KRAs
              </div>

              <div className="og-page-title">
                {employeeKraName?.FullName ? employeeKraName?.FullName : "My"}{" "}
                Goals & KRAs
              </div>

              <div className="og-page-sub">
                Goals are persistent — fill KPI progress anytime throughout the
                year. Manager sets KRAs; you update progress.
              </div>
            </div>

            <div className="og-right-header">
              <div className="d-flex align-items-center gap-2">
                <div
                  style={{
                    fontSize: 12,
                    color: "#8492a6",
                    alignSelf: "center",
                  }}
                >
                  Viewing as:
                </div>

                <select
                  className="og-select"
                  style={{ width: 220 }}
                  value={selectedEmployee}
                  onChange={handleEmployeeChange}
                >
                  <option value="">Select Employee</option>
                  <option value={userDetails?.EmpId} key={userDetails?.EmpId}>
                    {userDetails?.FullName}(Self)
                  </option>

                  {Array.isArray(employees) &&
                    employees.map((employee) => (
                      <option key={employee.EmpId} value={employee?.EmpId}>
                        {employee.FullName}
                      </option>
                    ))}
                </select>
                {!isPublished && (
                  <button
                    className="btn-og btn-og-primary"
                    onClick={openAddKra}
                  >
                    <i className="fa fa-plus"></i> Add KRA
                  </button>
                )}
              </div>

              {/* <Dropdown
                      name="fullName"
                      value={selectedEmployee}
                      onChange={(e) => {
                        setSelectedEmployee(e.value);
                        handleInputChangeEmployee(e);
                      }}
                      options={employeDetailsOfDropdown?.toSpliced(0, 0, {
                        ProfileImage: EmployeesNameData?.ProfileImage,
                        EmpId: EmployeesNameData?.EmpId,
                        FullName: EmployeesNameData?.FullName,
                        FirstName: EmployeesNameData?.FirstName,
                      })}
                      itemTemplate={employeeOptionTemplate}
                      valueTemplate={selectedAssignName}
                      filter
                      optionLabel="FullName"
                      placeholder="Employee"
                    /> */}
              <div className="d-flex align-items-center gap-2">

            {kraPublish &&  (
                <InputSwitch
                  checked={isPublished}
                  onChange={(e) => handlePublishUnpublish(e)}
                  disabled={
                    String(kraPublishStatus?.CycleStatus ?? "")
                      .trim()
                      .toLowerCase() !== "active"
                  }
                />
                )}
                {kraPublishStatus?.PublishStatus}

                {!isPublished && (
                  <button
                    type="button"
                    className=" btn btn-primary"
                    onClick={handleCopyPreviousKra}
                  >
                    Copy previous KRA
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* LOADING */}
          {loading && (
            <div
              style={{
                textAlign: "center",
                padding: 30,
                color: "#8492a6",
              }}
            >
              Loading goals...
            </div>
          )}

          {/* EMPTY */}
          {!loading && goals.length === 0 && (
            <div
              className="og-card"
              style={{
                textAlign: "center",
                padding: 40,
              }}
            >
              <div
                style={{
                  fontSize: 14,
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                No goals found
              </div>

              <div
                style={{
                  color: "#8492a6",
                  fontSize: 12,
                  marginBottom: 16,
                }}
              >
                Add your first KRA to get started.
              </div>
              {!isPublished && (
                <button className="btn-og btn-og-primary" onClick={openAddKra}>
                  <i className="fa fa-plus"></i> Add KRA
                </button>
              )}
            </div>
          )}

          {/* GOALS */}
          {!loading &&
            goals.map((kra, kraIndex) => {
              const kpis = getKpis(kra);
              const kraId = getKraId(kra);

              return (
                <div className="og-kra-card" key={kraId || kraIndex}>
                  {/* KRA HEADER */}
                  <div className="og-kra-header">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <div
                        style={{
                          width: 30,
                          height: 30,
                          background:
                            kraIndex % 3 === 0
                              ? "#EC4119"
                              : kraIndex % 3 === 1
                                ? "#7c3aed"
                                : "#2b6cb0",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#fff",
                          fontSize: 11,
                          fontWeight: 700,
                          flexShrink: 0,
                        }}
                      >
                        {getInitials(kraIndex)}
                      </div>

                      <div>
                        <div className="og-kra-title">{getKraTitle(kra)}</div>

                        <div
                          style={{
                            fontSize: 11.5,
                            color: "#8492a6",
                          }}
                        >
                          Target Date:{" "}
                          {getKraTargetDate(kra)
                            ? formatDate(getKraTargetDate(kra))
                            : "Ongoing"}{" "}
                          &nbsp;·&nbsp;
                          <span
                            style={{
                              color: "#276749",
                              fontWeight: 600,
                            }}
                          >
                            {kra?.Status}
                          </span>
                          {kra?.SetByName && (
                            <> &nbsp;·&nbsp; Set by {kra.SetByName}</>
                          )}
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        alignItems: "center",
                      }}
                    >
                      <label style={{ fontWeight: "bold", marginBottom: 0 }}>
                        Weightage: <span>{kra?.Weightage}%</span>
                      </label>
                      {!isPublished && (
                        <>
                          <button
                            className="btn-og btn-og-secondary btn-og-sm"
                            onClick={() => openAddKpi(kra)}
                          >
                            <i className="fa fa-plus"></i> Add KPI
                          </button>

                          <button
                            className="btn-og btn-og-secondary btn-og-sm"
                            onClick={() => openEditKra(kra)}
                            title="Edit KRA"
                          >
                            <i className="fa fa-pen"></i>
                          </button>

                          <button
                            className="btn-og btn-og-secondary btn-og-sm"
                            onClick={() => {
                              setSelectedDeleteKra(kra?.Id);
                              setDeleteKra(true);
                            }}
                            disabled={deleting}
                            title="Delete KRA"
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        </>
                      )}
                    </div>
                  </div>

                  {/* KRA DESCRIPTION */}
                  {getKraDescription(kra) && (
                    <div
                      style={{
                        fontSize: 12,
                        color: "#8492a6",
                        marginBottom: 10,
                      }}
                    >
                      {getKraDescription(kra)}
                    </div>
                  )}

                  {/* KPIs */}
                  {kpis.length === 0 && (
                    <div
                      style={{
                        padding: 18,
                        border: "1px dashed #dfe4ea",
                        borderRadius: 8,
                        color: "#8492a6",
                        fontSize: 12,
                      }}
                    >
                      No KPIs added yet.
                    </div>
                  )}

                  {kpis.map((kpi, kpiIndex) => {
                    const progress = getKpiProgress(kpi);

                    return (
                      <div
                        key={getKpiId(kpi) || kpiIndex}
                        style={{
                          border: "1px solid #e9ecf0",
                          borderRadius: 8,
                          padding: "5px 13px",
                          marginBottom: kpiIndex === kpis.length - 1 ? 0 : 8,
                          background: "#fff",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 10,
                          }}
                        >
                          <div
                            style={{
                              flex: 1,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: 10,
                                marginBottom: "6px",
                              }}
                            >
                              <div className="d-flex align-items-center gap-2">
                                <div
                                  className="og-kpi-dot"
                                  style={{
                                    marginTop: 0,
                                    flexShrink: 0,
                                  }}
                                ></div>
                                <div
                                  style={{
                                    fontSize: 13,
                                    fontWeight: 600,
                                    color: "#1a1a2e",
                                  }}
                                >
                                  {getKpiTitle(kpi)}
                                </div>
                                <div
                                  style={{
                                    fontSize: 11.5,
                                    color: "#8492a6",
                                    marginBottom: 0,
                                  }}
                                >
                                  Target Date:{" "}
                                  {getKpiTargetDate(kpi)
                                    ? formatDate(getKpiTargetDate(kpi))
                                    : "Ongoing"}
                                </div>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  gap: 6,
                                }}
                              >
                                {!isPublished && (
                                  <>
                                    <button
                                      className="btn-og btn-og-secondary btn-og-sm"
                                      onClick={() => openEditKpi(kra, kpi)}
                                      title="Edit KPI"
                                    >
                                      <i className="fa fa-pen"></i>
                                    </button>

                                    <button
                                      className="btn-og btn-og-secondary btn-og-sm"
                                      onClick={() => {
                                        setSelectedDeleteKpi(kpi?.Id);
                                        setDeleteKpi(true);
                                      }}
                                      disabled={deleting}
                                      title="Delete KPI"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>

                            {/* PROGRESS */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                              }}
                            >
                              <div
                                style={{
                                  flex: 1,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    fontSize: 11.5,
                                    color: "#8492a6",
                                    marginBottom: 3,
                                  }}
                                >
                                  <span>Progress</span>

                                  <span
                                    style={{
                                      fontWeight: 700,
                                      color:
                                        progress >= 80
                                          ? "#276749"
                                          : progress >= 50
                                            ? "#d97706"
                                            : "#2b6cb0",
                                    }}
                                  >
                                    {progress}%
                                  </span>
                                </div>

                                <div className="og-kpi-progress-bar">
                                  <div
                                    className="og-kpi-progress-fill"
                                    style={{
                                      width: `${progress}%`,
                                    }}
                                  />
                                </div>
                              </div>

                              <button
                                className="btn-og btn-og-outline btn-og-sm"
                                onClick={() => openProgress(kpi)}
                              >
                                <i className="fa fa-pen-to-square"></i> Update
                                Progress
                              </button>
                            </div>

                            {/* NARRATIVE */}
                            {getKpiNarrative(kpi) && (
                              <div
                                style={{
                                  marginTop: 8,
                                  fontSize: 11.5,
                                  color: "#8492a6",
                                }}
                              >
                                {getKpiNarrative(kpi)}
                              </div>
                            )}

                            {/* UPDATED */}
                            {/* {getKpiUpdatedDate(kpi) && (
                              <div
                                style={{
                                  fontSize: 11,
                                  color: "#8492a6",
                                  marginTop: 6,
                                }}
                              >
                                <i className="fa fa-clock"></i> Last updated{" "}
                                {formatDate(getKpiUpdatedDate(kpi))}
                                {getKpiUpdatedBy(kpi) && (
                                  <> by {getKpiUpdatedBy(kpi)}</>
                                )}
                              </div>
                            )} */}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}

          {/* =====================================================
                        ADD / EDIT KRA MODAL
                    ===================================================== */}

          {showAddKra && (
            <div className={`og-modal-overlay ${showAddKra ? "open" : ""}`}>
              <div className="og-modal">
                <div className="og-modal-header">
                  <div className="og-modal-title">
                    <i
                      className="fa fa-bullseye"
                      style={{
                        color: "#EC4119",
                      }}
                    ></i>{" "}
                    {editingKra ? "Edit KRA" : "Add KRA"}
                  </div>

                  <button className="og-modal-close" onClick={closeKraModal}>
                    <i className="fa fa-times"></i>
                  </button>
                </div>

                <div className="modal-body">
                  <div className="og-form-group">
                    <label className="og-label">KRA Title *</label>

                    <input
                      className="og-input"
                      type="text"
                      placeholder="e.g. Project Delivery & Execution"
                      value={kraTitle}
                      maxLength={150}
                      onChange={(e) => {
                        setKraTitle(e.target.value);

                        if (kraErrors.title) {
                          setKraErrors((prev) => ({
                            ...prev,
                            title: "",
                          }));
                        }
                      }}
                    />

                    {kraErrors.title && (
                      <div
                        style={{
                          color: "#e53e3e",
                          fontSize: 11.5,
                          marginTop: 5,
                        }}
                      >
                        <i className="fa fa-circle-exclamation"></i>{" "}
                        {kraErrors.title}
                      </div>
                    )}

                    {/* <div
                      style={{
                        fontSize: 10.5,
                        color: "#8492a6",
                        marginTop: 4,
                        textAlign: "right",
                      }}
                    >
                      {kraTitle.length}/150
                    </div> */}
                  </div>

                  <div className="og-form-group">
                    <label className="og-label">Target Date (indicatory)</label>

                    <input
                      className="og-input"
                      type="date"
                      value={kraTargetDate}
                      onChange={(e) => {
                        setKraTargetDate(e.target.value);

                        if (kraErrors.targetDate) {
                          setKraErrors((prev) => ({
                            ...prev,
                            targetDate: "",
                          }));
                        }
                      }}
                    />

                    {kraErrors.targetDate && (
                      <div
                        style={{
                          color: "#e53e3e",
                          fontSize: 11.5,
                          marginTop: 5,
                        }}
                      >
                        <i className="fa fa-circle-exclamation"></i>{" "}
                        {kraErrors.targetDate}
                      </div>
                    )}

                    <div className="og-hint">
                      <i className="fa fa-circle-info"></i> Target date is
                      indicatory and does not close the KRA automatically.
                    </div>
                  </div>

                  <div className="og-form-group">
                    <label className="og-label">Weightage (%) *</label>

                    <input
                      className="og-input"
                      type="number"
                      min="1"
                      max={Math.max(0, 100 - getExistingWeightage())}
                      step="0.01"
                      value={kraWeightage}
                      onChange={(e) => {
                        setKraWeightage(e.target.value);

                        if (kraErrors.weightage) {
                          setKraErrors((prev) => ({
                            ...prev,
                            weightage: "",
                          }));
                        }
                      }}
                      placeholder="Enter weightage"
                    />

                    {kraErrors.weightage && (
                      <div
                        style={{
                          color: "#e53e3e",
                          fontSize: 11.5,
                          marginTop: 5,
                        }}
                      >
                        <i className="fa fa-circle-exclamation" />{" "}
                        {kraErrors.weightage}
                      </div>
                    )}

                    <div className="og-hint">
                      Total allocated: {totalKraWeightage}% / 100%. Remaining:{" "}
                      {Math.max(0, 100 - getExistingWeightage())}%.
                    </div>
                  </div>
                  <div className="og-form-group">
                    <label className="og-label">Description</label>

                    <textarea
                      className="og-textarea"
                      placeholder="Describe the key result area..."
                      value={kraDescription}
                      maxLength={500}
                      onChange={(e) => {
                        setKraDescription(e.target.value);

                        if (kraErrors.description) {
                          setKraErrors((prev) => ({
                            ...prev,
                            description: "",
                          }));
                        }
                      }}
                    />

                    {kraErrors.description && (
                      <div
                        style={{
                          color: "#e53e3e",
                          fontSize: 11.5,
                          marginTop: 5,
                        }}
                      >
                        <i className="fa fa-circle-exclamation"></i>{" "}
                        {kraErrors.description}
                      </div>
                    )}

                    <div
                      style={{
                        fontSize: 10.5,
                        color: "#8492a6",
                        marginTop: 4,
                        textAlign: "right",
                      }}
                    >
                      {kraDescription.length}/500
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn-og btn-og-secondary"
                    onClick={closeKraModal}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn-og btn-og-primary"
                    onClick={handleSaveKra}
                    disabled={savingKra}
                  >
                    <i className="fa fa-save"></i>{" "}
                    {savingKra
                      ? "Saving..."
                      : editingKra
                        ? "Update KRA"
                        : "Add KRA"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* =====================================================
                        ADD / EDIT KPI MODAL
                    ===================================================== */}

          {showAddKpi && (
            <div className={`og-modal-overlay ${showAddKpi ? "open" : ""}`}>
              <div className="og-modal">
                <div className="og-modal-header">
                  <div className="og-modal-title">
                    <i
                      className="fa fa-circle-dot"
                      style={{
                        color: "#EC4119",
                      }}
                    ></i>{" "}
                    {editingKpi ? "Edit KPI" : "Add KPI"}
                  </div>

                  <button
                    className="og-modal-close"
                    onClick={() => setShowAddKpi(false)}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                </div>

                <div className="modal-body">
                  <div className="og-form-group">
                    <label className="og-label">KPI Description *</label>

                    <textarea
                      className="og-textarea"
                      placeholder="Describe the measurable key performance indicator..."
                      value={kpiDescription}
                      onChange={(e) => setKpiDescription(e.target.value)}
                    />
                  </div>

                  <div
                    className="og-form-group"
                    style={{
                      marginBottom: 0,
                    }}
                  >
                    <label className="og-label">Target Date (indicatory)</label>

                    <input
                      className="og-input"
                      type="date"
                      value={kpiTargetDate}
                      onChange={(e) => {
                        setKpiTargetDate(e.target.value);

                        if (kpiErrors.targetDate) {
                          setKpiErrors((prev) => ({
                            ...prev,
                            targetDate: "",
                          }));
                        }
                      }}
                    />

                    {kpiErrors.targetDate && (
                      <div
                        style={{
                          color: "#e53e3e",
                          fontSize: 11.5,
                          marginTop: 5,
                        }}
                      >
                        <i className="fa fa-circle-exclamation"></i>{" "}
                        {kpiErrors.targetDate}
                      </div>
                    )}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn-og btn-og-secondary"
                    onClick={() => setShowAddKpi(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn-og btn-og-primary"
                    onClick={handleSaveKpi}
                    disabled={savingKpi}
                  >
                    <i className="fa fa-save"></i>{" "}
                    {savingKpi
                      ? "Saving..."
                      : editingKpi
                        ? "Update KPI"
                        : "Add KPI"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* =====================================================
                        UPDATE PROGRESS MODAL
                    ===================================================== */}

          {showProgressModal && (
            <div
              className={`og-modal-overlay ${showProgressModal ? "open" : ""}`}
            >
              <div className="og-modal">
                <div className="og-modal-header">
                  <div className="og-modal-title">
                    <i
                      className="fa fa-pen-to-square"
                      style={{
                        color: "#EC4119",
                      }}
                    ></i>{" "}
                    Update KPI Progress
                  </div>

                  <button
                    className="og-modal-close"
                    onClick={() => setShowProgressModal(false)}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                </div>

                <div className="modal-body">
                  <div
                    style={{
                      fontSize: 13,
                      fontWeight: 600,
                      color: "#1a1a2e",
                      marginBottom: 14,
                      padding: 10,
                      background: "#f8f9fb",
                      borderRadius: 8,
                      borderLeft: "3px solid #EC4119",
                    }}
                  >
                    {progressKpiName}
                  </div>

                  <div className="og-form-group">
                    <label className="og-label">Completion % *</label>

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 12,
                      }}
                    >
                      <input
                        type="range"
                        min="0"
                        max="100"
                        value={progressPct}
                        style={{
                          flex: 1,
                          accentColor: "#EC4119",
                        }}
                        onChange={(e) => {
                          setProgressPct(Number(e.target.value));

                          if (progressErrors.progress) {
                            setProgressErrors((prev) => ({
                              ...prev,
                              progress: "",
                            }));
                          }
                        }}
                      />

                      <input
                        type="number"
                        min="0"
                        max="100"
                        value={progressPct}
                        onChange={(e) => {
                          const rawValue = e.target.value;

                          if (rawValue === "") {
                            setProgressPct("");
                            return;
                          }

                          let value = Number(rawValue);

                          if (value < 0) value = 0;
                          if (value > 100) value = 100;

                          setProgressPct(value);

                          if (progressErrors.progress) {
                            setProgressErrors((prev) => ({
                              ...prev,
                              progress: "",
                            }));
                          }
                        }}
                        style={{
                          width: 70,
                          padding: 8,
                          border: "1.5px solid #e9ecf0",
                          borderRadius: 8,
                          fontSize: 16,
                          fontWeight: 700,
                          textAlign: "center",
                          fontFamily: "inherit",
                          outline: "none",
                        }}
                      />

                      {progressErrors.progress && (
                        <div
                          style={{
                            color: "#e53e3e",
                            fontSize: 11.5,
                            marginTop: 5,
                          }}
                        >
                          <i className="fa fa-circle-exclamation"></i>{" "}
                          {progressErrors.progress}
                        </div>
                      )}

                      <span
                        style={{
                          fontSize: 14,
                          fontWeight: 700,
                          color: "#8492a6",
                        }}
                      >
                        %
                      </span>
                    </div>
                  </div>

                  <div
                    className="og-form-group"
                    style={{
                      marginBottom: 0,
                    }}
                  >
                    <label className="og-label">Progress Narrative</label>

                    <textarea
                      className="og-textarea"
                      placeholder="Briefly describe what you have achieved against this KPI..."
                      value={progressNarrative}
                      maxLength={1000}
                      onChange={(e) => {
                        setProgressNarrative(e.target.value);

                        if (progressErrors.narrative) {
                          setProgressErrors((prev) => ({
                            ...prev,
                            narrative: "",
                          }));
                        }
                      }}
                      style={{
                        minHeight: 90,
                      }}
                    />

                    {progressErrors.narrative && (
                      <div
                        style={{
                          color: "#e53e3e",
                          fontSize: 11.5,
                          marginTop: 5,
                        }}
                      >
                        <i className="fa fa-circle-exclamation"></i>{" "}
                        {progressErrors.narrative}
                      </div>
                    )}

                    <div
                      style={{
                        fontSize: 10.5,
                        color: "#8492a6",
                        marginTop: 4,
                        textAlign: "right",
                      }}
                    >
                      {progressNarrative.length}/1000
                    </div>

                    <div className="og-hint">
                      <i className="fa fa-circle-info"></i> This narrative
                      carries forward to your appraisal cycle. Update it
                      throughout the year to keep it accurate.
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn-og btn-og-secondary"
                    onClick={() => setShowProgressModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn-og btn-og-primary"
                    onClick={handleSaveProgress}
                    disabled={savingProgress}
                  >
                    <i className="fa fa-save"></i>{" "}
                    {savingProgress ? "Saving..." : "Save Progress"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {deleteKra && (
            <div className={`og-modal-overlay ${deleteKra ? "open" : ""}`}>
              <div className="og-modal">
                <div className="og-modal-header">
                  <div className="og-modal-title">
                    <i
                      className="fa fa-circle-dot"
                      style={{
                        color: "#EC4119",
                      }}
                    ></i>{" "}
                    Delete KRA
                  </div>

                  <button
                    className="og-modal-close"
                    onClick={() => setDeleteKra(false)}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                </div>

                <div className="modal-body">
                  <p> Are you sure you want to delete the KRA? </p>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn-og btn-og-secondary"
                    onClick={() => setDeleteKra(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn-og btn-og-primary"
                    onClick={handleDeleteKra}
                  >
                    <i className="fa fa-save"></i> Delete KRA
                  </button>
                </div>
              </div>
            </div>
          )}

          {deleteKpi && (
            <div className={`og-modal-overlay ${deleteKpi ? "open" : ""}`}>
              <div className="og-modal">
                <div className="og-modal-header">
                  <div className="og-modal-title">
                    <i
                      className="fa fa-circle-dot"
                      style={{
                        color: "#EC4119",
                      }}
                    ></i>{" "}
                    Delete KPI
                  </div>

                  <button
                    className="og-modal-close"
                    onClick={() => setDeleteKpi(false)}
                  >
                    <i className="fa fa-times"></i>
                  </button>
                </div>

                <div className="modal-body">
                  <p> Are you sure you want to delete the KPI? </p>
                </div>

                <div className="modal-footer">
                  <button
                    className="btn-og btn-og-secondary"
                    onClick={() => setDeleteKpi(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn-og btn-og-primary"
                    onClick={handleDeleteKpi}
                  >
                    <i className="fa fa-save"></i> Delete KPI
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssessmentGoals;
